import { Box, HStack, Text } from "@chakra-ui/react";
import { FaGift } from "react-icons/fa";

/**
 * Sponsored free-access offer badge (gift icon + short label). Shared by
 * FacilityHero and PartnerCta so a partner's offer pill stays visually
 * identical wherever it surfaces. Renders nothing without a `label`; forwards
 * style props (e.g. `mb`) and `data-testid` to the wrapper.
 */
export function OfferPill({ label, ...boxProps }) {
  if (!label) return null;

  return (
    <HStack
      display="inline-flex"
      align="center"
      spacing={2}
      px={3}
      py={1.5}
      borderRadius="full"
      bg="bg-muted"
      {...boxProps}
    >
      <Box as={FaGift} boxSize="14px" color="warning" aria-hidden="true" />
      <Text fontSize="sm" fontWeight="semibold">
        {label}
      </Text>
    </HStack>
  );
}
